<template>
    <form>
        <h4>
            Translations
        </h4>

        <form-alert />

        <series-translations-table
            :endpoint="`/admin/api/series-translations?series_id=${seriesId}`"
            :filters="{'series_id': seriesId}"
        />

        <hr />

        <div class="form-group">
            <label for="type">
                Type
            </label>
            <form-select
                v-model="mutableData.type"
                name="type"
                :options="{ 'title': 'Title', 'summary': 'Summary' }"
                data-vv-as="Type"
            >
            </form-select>
        </div>

        <div class="form-group">
            <label for="language_id">
                Language
            </label>
            <form-select
                v-model="mutableData.language_id"
                name="language_id"
                endpoint="/admin/api/languages-options"
                data-vv-as="Language"
            >
            </form-select>
        </div>

        <div class="form-group">
            <label for="content">
                Content
            </label>

            <div v-show="(mutableData.type === 'summary')">
              <trumbowyg
                v-model="mutableData.content"
                :config="config"
                class="form-control"
                name="summary"
                data-vv-as="Summary"
              />
            </div>

            <form-input
                v-if="(mutableData.type !== 'summary')"
                v-model="mutableData.content"
                name="content"
                data-vv-as="Content"
            />
        </div>

        <button
            :disabled="isSending"
            class="btn btn-success btn-block"
            @click.prevent="submitForm()"
        >
            Add
        </button>
    </form>
</template>

<script>
import Form from "../mixins/Form.js";
import SeriesTranslationsTable from "./SeriesTranslationsTable.vue";
import Trumbowyg from "../mixins/Trumbowyg";

export default {
  name: "SeriesTranslationsForm",

  components: {
    SeriesTranslationsTable,
  },

  mixins: [
    Form,
    Trumbowyg,
  ],

  mounted() {
    this.mutableData.series_id = this.seriesId;
  },

  props: {
    seriesId: {
      type: Number,
      required: true,
    },
  },
};
</script>
